function _typeof(o) {
    '@babel/helpers - typeof';
    return _typeof = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (o) {
        return typeof o;
    } : function (o) {
        return o && 'function' == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? 'symbol' : typeof o;
    }, _typeof(o);
}
module.exports = {
    getElementViewLeft: function getElementViewLeft(element) {
        var actualLeft = element.offsetLeft;
        var current = element.offsetParent;
        var elementScrollLeft = document.body.scrollLeft + document.documentElement.scrollLeft;
        if (!document.fullscreenElement && !document.mozFullScreenElement && !document.webkitFullscreenElement) {
            while (current !== null) {
                actualLeft += current.offsetLeft;
                current = current.offsetParent;
            }
        } else {
            while (current !== null && current !== element) {
                actualLeft += current.offsetLeft;
                current = current.offsetParent;
            }
        }
        return actualLeft - elementScrollLeft;
    },
    fullHeight: function fullHeight(obj) {
        var compstyle = typeof window.getComputedStyle === 'undefined' ? obj.currentStyle : window.getComputedStyle(obj);
        var marginTop = parseInt(compstyle.marginTop);
        var marginBottom = parseInt(compstyle.marginBottom);
        var paddingTop = parseInt(compstyle.paddingTop);
        var paddingBottom = parseInt(compstyle.paddingBottom);
        var borderTopWidth = parseInt(compstyle.borderTopWidth);
        var borderBottomWidth = parseInt(compstyle.borderBottomWidth);
        return obj.offsetHeight + (isNaN(marginTop) ? 0 : marginTop) + (isNaN(marginBottom) ? 0 : marginBottom) + (isNaN(paddingTop) ? 0 : paddingTop) + (isNaN(paddingBottom) ? 0 : paddingBottom) + (isNaN(borderTopWidth) ? 0 : borderTopWidth) + (isNaN(borderBottomWidth) ? 0 : borderBottomWidth);
    },
    getScrollPosition: function getScrollPosition() {
        return {
            left: window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0,
            top: window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
        };
    },
    setScrollPosition: function setScrollPosition(_ref) {
        var _ref$left = _ref.left, left = _ref$left === void 0 ? 0 : _ref$left, _ref$top = _ref.top, top = _ref$top === void 0 ? 0 : _ref$top;
        if (this.isFirefox) {
            document.documentElement.scrollLeft = left;
            document.documentElement.scrollTop = top;
        } else {
            window.scrollTo(left, top);
        }
    },
    extendArray: function extendArray(array, extend) {
        for (var key in extend) {
            if (Object.prototype.hasOwnProperty.call(extend, key)) {
                if (_typeof(array[key]) === 'object') {
                    array[key] = this.extendArray(array[key], extend[key]);
                } else
                    array[key] = extend[key];
            }
        }
        return array;
    },
    currentDateTime: function currentDateTime() {
        var now = new Date();
        return ''.concat(now.toLocaleDateString(), ' ').concat(now.toLocaleTimeString());
    },
    saveAs: function saveAs(uri, filename) {
        var link = document.createElement('a');
        if (typeof link.download === 'string') {
            link.href = uri;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else {
            window.open(uri);
        }
    },
    makevalue: function makevalue(value, index) {
        var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        if (!value) {
            return name || '';
        }
        if (typeof value === 'string') {
            return value;
        }
        if (typeof value === 'function') {
            return value(name, index);
        }
        if (Array.isArray(value)) {
            return value[index] || name;
        }
        return Object.prototype.hasOwnProperty.call(value, index) ? value[index] : name || '';
    },
    isMobile: /mobile/i.test(window.navigator.userAgent),
    isFirefox: /firefox/i.test(window.navigator.userAgent),
    isChrome: /chrome/i.test(window.navigator.userAgent),
    storage: {
        set: function set(key, value) {
            localStorage.setItem(key, value);
        },
        get: function get(key) {
            return localStorage.getItem(key);
        }
    }
};